import { useQuery } from '@tanstack/react-query';
import { VehicleBrokerSubmissionApi } from 'api';

export function useGetVehicleBrokerSubmission(vehicleId) {
  return useQuery({
    queryKey: ['vehicle-broker-submission', vehicleId],
    queryFn: () => VehicleBrokerSubmissionApi.search(vehicleId),
  });
}
